import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetIncidentCausesInputDto, IncidentCauseCreateDto, IncidentCauseDto, IncidentCauseExcelDownloadDto, IncidentCauseUpdateDto } from '../dtos/incident-cause/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class IncidentCauseService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: IncidentCauseCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentCauseDto>({
      method: 'POST',
      url: '/api/planning/incidentCauses',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/incidentCauses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/incidentCauses',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentCauseDto>({
      method: 'GET',
      url: `/api/planning/incidentCauses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/incidentCauses/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIncidentCausesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IncidentCauseDto>>({
      method: 'GET',
      url: '/api/planning/incidentCauses',
      params: { incidentCategoryId: input.incidentCategoryId, incidentCategoryName: input.incidentCategoryName, incidentTypeName: input.incidentTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: IncidentCauseExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/incidentCauses/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, incidentCategoryId: input.incidentCategoryId, incidentCategoryName: input.incidentCategoryName, incidentTypeName: input.incidentTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentCauseDto[]>({
      method: 'GET',
      url: '/api/planning/incidentCauses/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: IncidentCauseUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentCauseDto>({
      method: 'PUT',
      url: `/api/planning/incidentCauses/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}